// extracted by mini-css-extract-plugin
export default {"card":"LoyaltyBanner_card__Hveb2","card_loading":"LoyaltyBanner_card_loading___LHtL","title":"LoyaltyBanner_title__lQu_2"};